export default class MyCoursesDialog extends HTMLDivElement {

    connectedCallback() {

        this.addEventListener('show.bs.modal', this.setCourseId);
        
    }

    disconnectedCallback() {

        this.removeEventListener('show.bs.modal', this.setCourseId);

    }

    setCourseId(e) {

        this.courseOccasionId = e.relatedTarget.dataset.courseId;

    }

    get courseOccasionId() {
        return document.querySelector("[name='courseOccasionId']").value;
    }

    set courseOccasionId(value) {
        document.querySelector("[name='courseOccasionId']").value = value;
    }

}

customElements.define('my-courses-dialog', MyCoursesDialog, { extends: 'div' });